import { FC } from "react";
import { FiBarChart } from "react-icons/fi";
import { useParams } from "react-router-dom";
import { TSTitleCard } from "../../../../components/shared/card/Card";
import { secondsToTimeString } from "../../../../helpers/dateHelper";
import { SummaryDay } from "../../../../services/summary/summary.types";
import { strings } from "../../../../services/translation/strings";
import { useWorkRules } from "../../../../services/workRules/useWorkRules";

interface TeamMemberTimeWorkedCardProps {
  dateString: string;
  employeeSchedule: SummaryDay[];
}

export const TeamMemberTimeWorkedCard: FC<TeamMemberTimeWorkedCardProps> = ({dateString, employeeSchedule}) => {
  const { userId } = useParams<'userId'>();
  const {rules} = useWorkRules(userId!)
  let shifts = 0;
  let freeDays = 0;
  let totalHours = 0;

  employeeSchedule.forEach(day => {
    if (day.shifts.length > 0) {
      shifts += day.shifts.length;
      day.shifts.forEach(shift => {
        totalHours += (shift.end - shift.start);
      })
    } else if (day.availableTimes && day.availableTimes.length > 0) {
      freeDays ++; 
    }
  });

  return (
    <TSTitleCard className='bg-white'
        title={strings.timeshift.teamMember.timeWorked.cardTitle(dateString)}
        icon={FiBarChart}>
      <div className="grid grid-cols-3 gap-2">
        <div className="flex flex-col">
          <span className="font-semibold">{strings.timeshift.teamMember.timeWorked.totalShiftsScheduled}</span>
          <span>{shifts}</span>
        </div>
        <div className="flex flex-col col-span-2">
          <span className="font-semibold">{strings.timeshift.teamMember.timeWorked.totalFreeDays}</span>
          <span>{freeDays}</span>
        </div>
        <div className="flex flex-col">
          <span className="font-semibold">{strings.timeshift.teamMember.timeWorked.hoursWorked}</span>
          <span>{secondsToTimeString(totalHours)}</span>
        </div>
        <div className="flex flex-col">
          <span className="font-semibold">{strings.timeshift.teamMember.timeWorked.minimumHours}</span>
          <span>{secondsToTimeString(rules.minMonthlyHours)}</span>
        </div>
        <div className="flex flex-col">
          <span className="font-semibold">{strings.timeshift.teamMember.timeWorked.maximumHours}</span>
          <span>{secondsToTimeString(rules.maxMonthlyHours)}</span>
        </div>
      </div>
    </TSTitleCard>
  )
}